import React, { useEffect, useState } from 'react';
import TrendCard from '../TrendCard';
import HBarChart from './HBarChart';
import { canRequest } from '../utils';
import { getStudioInfluencers } from '@op/services';
import { useIntl } from 'umi';
import { NO_DATE } from '@op/constants';
import {
  influencerColorMap,
  influencerSortMap,
} from '@op/pages/Influencer/constants';

export default function Influencers({ filter }: { filter: any; }) {
  const [channelBar, setChannelBar] = useState([]);
  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(false);
  function requestServerData() {
    setLoading(true);
    getStudioInfluencers(filter)
      .then((data: any) => {
        const { list } = data || {};
        setChannelBar(list || []);
      }).catch(() => {}).finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (canRequest(filter)) {
      requestServerData();
    }
  }, [filter]);

  const translate = (text: string) =>
    formatMessage({ id: text || NO_DATE.EMPTY });

  return (
    <TrendCard
      title="Influencers"
      className="dbh-trend-card--influencers"
      loading={loading}
      filter={filter}
      loadingHeight={160}
      moduleType={'influencers'}
      empty={channelBar.length === 0}
      emptyHeight={160}
      hasEmptyDesc={false}
    >
      <HBarChart
        filter={filter}
        title={formatMessage({ id: 'Mentions' })}
        translate={translate}
        data={channelBar}
        colorMap={influencerColorMap}
        sortMap={influencerSortMap}
        height={148}
      ></HBarChart>
    </TrendCard>
  );
}
